import Head from 'next/head';
import React from 'react';
import ProfileWidget from '../../components/sections/profile';
import DashboardLayout from '../../components/widgets/dashboard-layout';
import Protected from '../../hoc/protected-route';

const Profile = () => {
  return (
    <>
      <Head>
        <title>Profile</title>
        <meta
          name="description"
          content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
        />
        <link rel="icon" href="/favicon.png" />
      </Head>
      <ProfileWidget />
    </>
  );
};

export default Protected(Profile);
